module.exports = __webpack_public_path__ + "static/UnclickLiability-443b1c748c33fa4ad4d5057c4c7696ed.png";